import { render, staticRenderFns } from "./ArchivesStatisticst.vue?vue&type=template&id=1146b6c3&scoped=true"
var script = {}
import style0 from "./ArchivesStatisticst.vue?vue&type=style&index=0&id=1146b6c3&prod&lang=less&scoped=true"
import style1 from "./ArchivesStatisticst.vue?vue&type=style&index=1&id=1146b6c3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1146b6c3",
  null
  
)

export default component.exports